module.exports = __webpack_public_path__ + "static/media/Ellipsis-horizontal-active.2e01233f.svg";